export default "__VITE_ASSET__DqukAVwz__"